export default __webpack_public_path__ + "static/media/banner-39.7081a958.jpg";